import { parseAsStringLiteral, useQueryState } from 'nuqs';

export const PHASE_VALUES = ['notStarted', 'inProgress', 'completed'];

const AssignmentPhaseTabs = () => {
  const [phase, setPhase] = useQueryState(
    'phase',
    parseAsStringLiteral(PHASE_VALUES).withDefault('inProgress'),
  );

  return (
    <>
      <div className="flex gap-8 mb-8">
        <button
          onClick={() => setPhase('inProgress')}
          className={`pb-3 border-b-2 font-medium ${
            phase === 'inProgress'
              ? 'border-gray-900 text-gray-900'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          진행 중 과제
        </button>
        <button
          onClick={() => setPhase('notStarted')}
          className={`pb-3 border-b-2 font-medium ${
            phase === 'notStarted'
              ? 'border-gray-900 text-gray-900'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          예정된 과제
        </button>
        <button
          onClick={() => setPhase('completed')}
          className={`pb-3 border-b-2 font-medium ${
            phase === 'completed'
              ? 'border-gray-900 text-gray-900'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          완료 과제
        </button>
      </div>
    </>
  );
};

export default AssignmentPhaseTabs;
